import { uniq } from 'lodash'
import PropTypes from 'prop-types'
import { React, Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import RadioButtons from '../../../../components/forms/RadioButtons'
import Select from '../../../../components/forms/Select'
import NetworkAction from '../../../../referencial/components/network/actions/NetworkAction'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import AppStore from '../../../../store/AppStore'
import Job from '../../../dto/DtoJob'
import SuperMultiAutocomplete from '../../../../components/forms/SuperMultiAutocomplete'
import SupportDto from '../../../../referencial/components/support/dto/SupportDto'
import Supportaction from '../../../../referencial/components/support/actions/SupportAction'
import WaterMassAction from '../../../../referencial/components/watermass/actions/WatermassAction'
import WaterMassDto from '../../../../referencial/components/watermass/dto/WatermassDto'
import MultiContributorsAutocomplete from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import ContributorDto from 'referencial/components/contributor/dto/ContributorDto'
import ImportQualityDefaultValue from '../ImportQualityDefaultValue'
import FractionAction from '../../../../referencial/components/fraction/actions/FractionAction'
import FractionDto from '../../../../referencial/components/fraction/dto/FractionDto'
import QualityAction from '../../../../quality/actions/QualityAction'
import DtoQualification from '../../../../quality/dto/DtoQualification'
import DtoStatus from '../../../../quality/dto/DtoStatus'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import { getIntegrationModes, getImportMode } from '../../../../utils/JobUtils'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'
import { readImportCsvStationsCodes } from '../../utils/ImportUtils'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { Grid } from '@mui/material'

class ImportQuadrigePanel extends Component {
    componentDidMount() {
        const filters = this.getFilters()
        this.onChangeFilters({ selectStationsMode: filters.selectStationsMode
                                || 'codesMode', stationCodes: filters.stationCodes
                                || (this.props.job.parameters.supports && this.props.job.parameters.supports.length ? this.props.job.supports.parameters : []),
        })
        this.props.fetchNetworks()
        this.props.fetchWatermasses()
        if (!this.props.qualifications.length) {
            this.props.fetchQualifications()
        }
        if (!this.props.status.length) {
            this.props.fetchStatus()
        }
        if (!this.props.fractions.length) {
            this.props.fetchFractions()
        }
        if (!this.props.supports.length) {
            this.props.fetchSupports()
        }
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        this.props.fetchQualityCampaigns()
    }

    onDeleteCode = (s) => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            this.onChangeFilters({ stationCodes: filters.stationCodes.filter(p => p !== s.credentials) })
        }
    }

    addBssCode = () => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            const code = this.refs.txtAddBssCode.value
            const exist = filters.stationCodes.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.onChangeFilters({ stationCodes: [ code, ...filters.stationCodes ] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }

    onChangeBssFile = e => {
        if (this.props.isEditMode) {
            readImportCsvStationsCodes(e, this.refs, (codes) => {
                const filters = this.getFilters()
                this.onChangeFilters({ stationCodes: uniq([ ...filters.stationCodes, ...codes ]) })
            })
        }
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    getStations = () => {
        return this.getFilters().stationCodes.map((v) => ({ credentials: v }))
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }


    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('station'))
        if (integration) {
            dataTypes.push('stationIntegration')
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return { descriptionImportMode: 'all', addCodesToADESNetwork: true, ...newFilters }
    }

    getStationsPanel = () => {
        const disabled = { disabled: !this.props.isEditMode }
        const myData =this.getStations()
        return (
            <div>
                <div className='row no-margin valign-wrapper'>
                    <div className='col s3'>
                        <label>{ i18n.importFile }</label>
                    </div>
                    <div className='file-field col s9 no-padding input-field'>
                        <div className='col s3 no-padding btn'>
                            <span>{ i18n.importLabel }</span>
                            <input
                                type='file'
                                ref='importFile'
                                accept='.csv'
                                onChange={ this.onChangeBssFile }
                                {...disabled}
                            />
                        </div>
                        <div className='file-path-wrapper col s9'>
                            <input
                                className='file-path'
                                ref='fileInput'
                                type='text'
                                placeholder={ i18n.selectedFile }
                                {...disabled}
                            />
                        </div>
                    </div>
                </div>
                <div className='row valign-wrapper'>
                    <div className='col s3'>
                        <label>{ i18n.addCredential }</label>
                    </div>
                    <div className='input-field col s9 no-padding'>
                        <div className='col s8'>
                            <input
                                id='txtAddBssCode'
                                type='text'
                                placeholder={ i18n.BSSExample }
                                ref='txtAddBssCode'
                                {...disabled}
                            />
                            <label className='tinyLabel'>{ i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode }</label>
                        </div>
                        <a
                            className='waves-effect waves-light btn col offset-s1 s3'
                            onClick={ this.addBssCode }
                            {...disabled}
                        >
                            { i18n.add }
                        </a>
                    </div>
                </div>
                <div className='row valign-wrapper'>
                    <div className='col s12'>
                        <CardTable
                            rows={ myData }
                            headers={ ['credentials']}
                            title={ i18n.credentials }
                            lineActions={[{
                                icon: 'delete',
                                onClick: (s) => this.onDeleteCode(s),
                                displayed: this.props.isEditMode,
                            }]}
                            rowsPerPageOptions={ nbPerPageLabelMedium }
                            data-cy='Synop_table_body'
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                    titleFile: i18n.credentials,
                                }),
                                tooltip: i18n.download,
                            }]}
                            displayHeaders={false}
                        />
                    </div>
                </div>
            </div>
        )
    }

    getFiltersPanel = (filters) => {
        const disabled = { disabled: !this.props.isEditMode }
        return (
            <Grid container spacing={2}>
                <Grid size={5}>
                    <Select
                        options={ this.props.networks }
                        keyLabel='mnemonic'
                        label={ i18n.network }
                        nullLabel='&nbsp;'
                        onChange={ value => this.onChangeFilters({ network: value }) }
                        value={ filters.network } {...disabled}
                        keyValue='id'
                    />
                </Grid>
                <Grid size={5}>
                    <Select
                        options={ this.props.watermass }
                        keyLabel='mnemonic'
                        label={ i18n.watermass }
                        nullLabel='&nbsp;'
                        onChange={ value => this.onChangeFilters({ codesMassesEau: value }) }
                        value={ filters.codesMassesEau }
                        {...disabled}
                        keyValue='id'
                    />
                </Grid>
            </Grid>
        )
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const selectModes = [
            { code: 'codesMode', name: i18n.stations },
            { code: 'filtersMode', name: i18n.filters },
        ]
        const filters = this.getFilters()
        return (
            <>
                <Grid container spacing={2}>
                    <Grid size={4}>
                        <Select
                            value={getImportMode(this.getDataTypes('DATA'))}
                            options={getIntegrationModes()}
                            label={ i18n.dataIntegration }
                            labelSpan={ <IntegrationModeDialog /> }
                            onChange={this.handleChangeDataIntegration}
                            {...disabled}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={4}>
                        <Select
                            value={filters.campaignId}
                            keyValue='id'
                            options={this.props.qualityCampaigns.filter(cs => cs.campaignType === 3)}
                            label={i18n.campaign}
                            onChange={v => this.onChangeFilters({ campaignId: v })}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={4}>
                        <SuperMultiAutocomplete
                            label={ i18n.support }
                            options={ this.props.supports }
                            keyLabel='labelWithCode'
                            onChange={ values => this.onChangeFilters({ supports: values }) }
                            values={ filters.supports }
                            multiple
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <MultiContributorsAutocomplete
                            multiple
                            options={this.props.contributors}
                            values={filters.excludedProducers}
                            label={ i18n.producersExcluded }
                            onChange={values => {
                                this.onChangeFilters({ excludedProducers: values })
                            }}
                            {...disabled}
                        />
                    </Grid>
                </Grid>
                <ImportQualityDefaultValue
                    defaultValue={filters}
                    onChange={obj => this.onChangeFilters(obj) }
                    isEditMode={this.props.isEditMode}
                />
                <Grid container spacing={2} paddingTop={2}>
                    <Grid size={3}>
                        <RadioButtons
                            title={ i18n.selectionMode }
                            elements={ selectModes }
                            onChange={ v => this.onChangeFilters({ selectStationsMode: v }) }
                            selected={ filters.selectStationsMode }
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={ filters.addCodesToADESNetwork }
                            label={ i18n.addCodesToADESNetwork }
                            onChange={ v => this.onChangeFilters({ addCodesToADESNetwork: v }) }
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            options={ this.props.networks }
                            keyLabel='mnemonic'
                            label={ i18n.synchNetwork }
                            nullLabel='&nbsp;'
                            onChange={ value => this.onChangeFilters({ selectedNetwork: value }) }
                            value={ filters.selectedNetwork }
                            disabled={ disabled.disabled || !filters.addCodesToADESNetwork }
                            keyValue='id'
                        />
                    </Grid>
                </Grid>
                { filters.selectStationsMode === 'codesMode' ? this.getStationsPanel() : this.getFiltersPanel(filters) }
            </>
        )
    }
}

ImportQuadrigePanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addBssCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    supports: PropTypes.arrayOf(PropTypes.instanceOf(SupportDto)),
    networks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkDto)),
    watermass: PropTypes.arrayOf(PropTypes.instanceOf(WaterMassDto)),
    qualifications: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualification)),
    status: PropTypes.arrayOf(PropTypes.instanceOf(DtoStatus)),
    fractions: PropTypes.arrayOf(PropTypes.instanceOf(FractionDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    fetchSupports: PropTypes.func,
    fetchNetworks: PropTypes.func,
    fetchWatermasses: PropTypes.func,
    fetchQualifications: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchContributors: PropTypes.func,
    fetchFractions: PropTypes.func,
    fetchContributor: PropTypes.func,
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    fetchQualityCampaigns: PropTypes.func,
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
    supports: store.SupportReducer.supports,
    watermass: store.WatermassReducer.watermasses,
    qualifications: store.QualityReducer.qualifications,
    status: store.QualityReducer.status,
    fractions: store.FractionReducer.fractions,
    contributors: store.ContributorReducer.contributors,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchNetworks: NetworkAction.fetchNetworks,
    fetchSupports: Supportaction.fetchSupports,
    fetchWatermasses: WaterMassAction.fetchWatermasses,
    toastrError: ToastrAction.error,
    fetchContributors: ContributorAction.fetchContributors,
    fetchStatus: QualityAction.fetchStatus,
    fetchQualifications: QualityAction.fetchQualifications,
    fetchFractions: FractionAction.fetchFractions,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportQuadrigePanel)